import { stylesheet } from 'typestyle';
import { flexRoot } from 'csstips';
import { regularGrayText } from '@styles/general';

export default stylesheet({
  container: {
    ...flexRoot,

    marginRight: 'auto',
    paddingTop: 2,
    paddingBottom: 7,

    $nest: {
      '&.borders': {
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
      },
      '.product-detail--container.combo-ring &': {
        marginBottom: 8
      }
    }
  },
  fedex: {
    marginTop: 13,
    height: 9,
    float: 'left',
    marginLeft: 11,
    marginRight: 9
  },
  text: {
    display: 'block',
    fontSize: 13,
    lineHeight: '17px',
    color: regularGrayText
  }
});
